import { forwardRef } from 'react';
import { styled } from 'goober';
import { RouteLink } from './route-link';

export const Link = styled(RouteLink, forwardRef)<{
  color?: string;
  weight?: string;
  withEllipsis?: boolean;
  maxWidth?: string;
}>`
  ${({ theme }) => theme.typography.widget.smallText}
  color: ${({ theme, color }) => color ?? theme.colors.blue.primaryA};
  text-decoration: none;
  font-weight: ${({ weight }) => weight ?? '400'};
  display: block;
  max-width: ${({ maxWidth }) => maxWidth ?? '100%'};

  ${({ withEllipsis, theme }) => withEllipsis && theme.mixins.ellipsis};

  &:hover {
    text-decoration: underline;
  }
`;
